import http from './httpService'

/*** Add or update registry information to database ***/
export function saveRegistry(starObj) {
  if (!starObj) return console.log('starObj is undefined')
  console.log(starObj)
  return http.post(`/registries`, starObj)
}

/*** Delete a registry from database ***/
export function deleteRegistry(regKey) {
  if (!regKey) return console.log('regKey is undefined')

  return http.delete(`/registries/${regKey}`)
}

/*** Get single registry info ***/
export function getRegistry(regKey) {
  console.log('regKey', regKey)
  return http.get(`/registries/${regKey}`)
}
